export class ClickEvents {
  constructor () {
    this.handleClick = this.handleClick.bind(this)

    document.addEventListener('click', this.handleClick)
  }

  handleClick (e) {
    const target = e.target.closest(this.targetSelector)
    if (!target) return

    const isAnchor =
      target.tagName === 'A' &&
      target.hasAttribute('href') &&
      target.dataset.clickType !== 'button'
    if (isAnchor) e.preventDefault()

    const dataString = target.dataset.clickEventsProperties
    if (!dataString) return

    let dataObject

    try {
      dataObject = JSON.parse(dataString)
    } catch (err) {
      console.error('Invalid JSON in data-click-events-properties', err)
      return
    }

    if (dataObject?.event) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(dataObject)
    }

    if (isAnchor) {
      window.location.href = target.getAttribute('href')
    }
  }

  get targetSelector () {
    return `[data-click-events-el="target"]`
  }
}

/* eslint-disable */
document.addEventListener('DOMContentLoaded', () => {
  new ClickEvents()
})
/* eslint-enable */
